module.exports = __webpack_public_path__ + "brain.jpg?aae14a67a2c28906410d0b317d984e20";